import React from "react";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import CircularProgress from "@material-ui/core/CircularProgress";
import { api } from "../services/index";
import { connect } from "../recontext/store";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    borderRadius: 8,
    background: "rgba(3,155,229,0.7)",
    boxShadow: "0 10px 34px rgba(3,155,229,.4), 0 2px 16px rgba(3,155,229,.2);",
    "&:hover": {
      background: "rgba(3,155,229,1)"
    }
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  }
});

class ButtonAccept extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = { loading: false };
  }

  async handleClick() {
    this.setState({
      loading: true
    });

    const { teamId } = this.props;
    const status = await api.acceptLiker(teamId);
    if (!status)
      this.setState({
        loading: false
      });
  }

  render() {
    const { classes, teamLikers, teamId, user, teams } = this.props;
    const { loading } = this.state;

    if (!user || !teams[user.teamId] || !teamLikers[user.teamId]) return null;

    const singleMember = teams[teamId].members.length === 1;
    const myTeamIsMax = teams[user.teamId].members.length === 5;
    const myTeamLikers = teamLikers[user.teamId] || [];
    const isLikedMyTeam = myTeamLikers.indexOf(teamId) > -1;

    if (!singleMember || !isLikedMyTeam || myTeamIsMax) return null;

    return (
      <Button
        variant="contained"
        color="secondary"
        className={classes.button}
        onClick={this.handleClick}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress className={classes.leftIcon} size={24} />
        ) : (
          <Icon className={classes.leftIcon}>thumbs_up_down</Icon>
        )}
        Accept
      </Button>
    );
  }
}

const mapStateToProps = state => ({
  teams: state.teams,
  user: state.user,
  teamLikers: state.teamLikers
});

export default connect(mapStateToProps)(withStyles(styles)(ButtonAccept));
